export default __webpack_public_path__ + "images/db8abc6c7851cda583b74ffce063748d-order_receipt.png";